module.exports = __webpack_public_path__ + "static/media/img-bdeadeb1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif/h-safati-2.gif
// module id = 5273
// module chunks = 39